import { render, staticRenderFns } from "./motivosdenuncia.vue?vue&type=template&id=6ce2149a"
import script from "./motivosdenuncia.vue?vue&type=script&lang=js"
export * from "./motivosdenuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports